import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'logged_out_retailers-logged_out_home_redesign_cta-click';

/**
 * track click event on logged out home (redesign)
parameter: 1. cta name 2. link
*/
export function trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
  cta_name: string,
  link2: string,
  variant_string3: string = 'CONTROL'
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { cta_name, link2, variant_string3 },
  });
}
